<OrderSummary @submit="emit('submit')" />
<ClubPoints v-if="showClubPoints" />
<CartVoucherBlock />
<FreeSamplesBlock v-if="allowedFreeSamples" />
<NewsletterSubscriptionToggle v-if="showNewsletterToggle" />
<Disclaimer />
